import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
    Wrapper: {
        height: "auto",
        width: "100%",
        position: "relative",
    },
    TopRow: {
        display: "flex",
        alignItems: "center",
        gap: "24px",
        minHeight: "50px",
        padding: "0 10px",
    },
    ToMain: {
        fontSize: "20px",
        cursor: "pointer",
    },
    AddButton: {
        marginLeft: "auto !important",
    },
    Info: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        padding: "8px 10px 16px",
        maxWidth: "900px",
    },
    Cell: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
    },
    FileName: {
        wordBreak: "break-all",
    },
    Actions: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "4px",
    },
    Dropzone: {
        width: "100%",
        padding: "24px 16px",
        border: "2px dashed #fc7f03",
        borderRadius: "12px",
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: "#fff8f0",
    },
    DropzoneActive: {
        backgroundColor: "#ffe7cc",
    },
    TabToolbar: {
        display: "flex",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap",
        padding: "0 10px 12px",
    },
    TabBadge: {
        paddingRight: "12px",
    },
    SettingsCard: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        margin: "0 10px 16px",
        padding: "12px 16px",
        maxWidth: "900px",
        border: "1px solid #fc7f03",
        borderRadius: "12px",
        backgroundColor: "#fff8f0",
    },
    DialogTitle: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
    },
    DeclarationFiles: {
        display: "flex",
        gap: "24px",
        flexWrap: "wrap",
    },
    DeclarationFile: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        minWidth: "240px",
    },
    IdPhotoImage: {
        display: "block",
        maxWidth: "360px",
        maxHeight: "260px",
        objectFit: "contain",
        border: "1px solid #ddd",
        borderRadius: "8px",
    },
    SignatureImage: {
        display: "block",
        width: "320px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#fff",
    },
}));
